import { Injectable } from "@angular/core";
import { HttpResponse } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class FileService {

    createFileFromHttpResponse(response: HttpResponse<Blob>): File {
        const blob = response.body as Blob;
        const contentDisposition = response.headers.get('content-disposition');
        const fileName = this.extractFileName(contentDisposition) || 'ddd-file';
        return new File([blob], fileName);
    }

    saveFile(file: File, fileName?: string | null): void {
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName?.trim() ? fileName : file.name;

        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }

    private extractFileName(contentDisposition: string | null): string | null {
        if (!contentDisposition) {
            return null;
        }

        const matches = /filename="(.+)"/.exec(contentDisposition);
        return matches ? matches[1] : null;
    }

}